/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { BabylonAddressSummaryInfo } from './BabylonAddressSummaryInfo';
import type { BabylonTokenSummaryInfo } from './BabylonTokenSummaryInfo';

export type BabylonTokenTransferInfo = {
    TKNSMR: BabylonTokenSummaryInfo;
    TP: string;
    AMT: string;
    VAL: string;
    ISOUT: string;
    ADDRSFROMINFO: BabylonAddressSummaryInfo;
    ADDRSTOINFO: BabylonAddressSummaryInfo;
    TRXHA: string;
    BNO: string;
    STAT: BabylonTokenTransferInfo.STAT;
    AGE: string;
    UT: number;
};

export namespace BabylonTokenTransferInfo {

    export enum STAT {
        SUCCESS = 'SUCCESS',
        FAILURE = 'FAILURE',
        PENDING = 'PENDING',
        FAILED = 'FAILED',
        OUT_COMING = 'OUT_COMING',
        IN_COMING = 'IN_COMING',
        ALL = 'ALL',
    }


}

